import React, { useEffect, useState } from 'react'
import axios from 'axios';
import Footer from '../components/Footer'
import Steps from '../components/Home/Steps'
import OurApp2 from '../components/BookService/OurApp2'
import PaymentMethod from '../components/BookService/PaymentMethod'
import Navbar from '../components/Navbar'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCategories } from '../redux/categoriesSlice'
import { useTranslation } from 'react-i18next'
import Vector5 from "../assets/services/Vector5.png";
import { Breadcrumb, Button, DatePicker, Form, Input, message, Select, TimePicker, Upload } from "antd";
import user from "../assets/user.png";
import mail from "../assets/mail.png";
import camira from "../assets/camira.png";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { UploadOutlined } from "@ant-design/icons";
import { fetchCountries } from '../redux/countriesSlice'
import { createOrder } from '../redux/createOrderSlice'
import dayjs from "dayjs";

const { TextArea } = Input;

const BookService = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const categoryId = parseInt(id);

  const [coordinates, setCoordinates] = useState({ lat: null, lon: null });

  const [formData, setFormData] = useState({
    category_id: categoryId,
    address: "",
    date: null,
    time: null,
    description: "",
    points: 0,
    images: [],
    sub_category: null,
    latitude: null,
    longitude: null,
  });

  const fetchCoordinates = async () => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search`,
        {
          params: {
            q: formData.address,
            format: "json",
            addressdetails: 1,
            limit: 1,
          },
        }
      );

      if (response.data.length > 0) {
        const location = response.data[0];
        const newCoordinates = { lat: location.lat, lon: location.lon };
        setCoordinates(newCoordinates);

        setFormData((prev) => ({
          ...prev,
          latitude: newCoordinates.lat || null,
          longitude: newCoordinates.lon || null,
        }));
      } else {
        console.log("No results found for the given address.");
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
    }
  };

  useEffect(() => {
    if (formData.address.length > 0) {
      fetchCoordinates();
    }
  }, [formData.address]);

  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [cities, setCities] = useState([]);

  const [selectedSubService, setSelectedSubService] = useState("");
  const [phone, setPhone] = useState("");

  const { categories, status, error } = useSelector((state) => state.categories);
  const countries = useSelector((state) => state.countries.countries);
  const countriesStatus = useSelector((state) => state.countries.status);
  const { loadingForm, errorForm } = useSelector((state) => state.createOrder);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCategories());
    }
    if (countriesStatus === "idle") {
      dispatch(fetchCountries());
    }
  }, [status, countriesStatus, dispatch]);

  const category = categories.find((category) => category.id === categoryId);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCountrySelect = (value) => {
    setSelectedCountry(value);

    const selected = countries?.Country?.find(
      (country) => country.id === value
    );

    setCities(selected?.city || []);
  };

  const handleSubServicesSelect = (value) => {
    setSelectedSubService(value);
  };

  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList);
    setFormData((prev) => ({
      ...prev,
      images: fileList.map((file) => file.originFileObj),
    }));
  };


  const handleSubmit = () => {

    const apiData = {
      ...formData,
      sub_category: selectedSubService || null,
      images: fileList.map((file) => file.originFileObj),
    };

    dispatch(createOrder(apiData))
      .unwrap()
      .then(() => {
        message.success(t("Your request has been successfully submitted and is now pending. A technician will be assigned shortly to assist you with your needs. Thank you for your patience!"));
        navigate("/myorders");
      })
      .catch((error) => {
        message.error(`Error booking service: ${error.message || error}`);
      });
  };

  const selectedCountryName =
    language === "en"
      ? countries?.Country?.find((country) => country.id === selectedCountry)
        ?.name_en
      : countries?.Country?.find((country) => country.id === selectedCountry)
        ?.name;

  return (
    <div>
      <Navbar />

      <div>
        <div className="relative px-20 max-lg:px-5">
          <div className="mt-10 mb-24 max-lg:mb-14">
            <img src={`https://service.samoolah.com/${category?.icon}`} width="250" className="w-[190] max-lg:w-[150px] mx-auto" />
            <h1 className="text-[#14294F] text-4xl max-lg:text-2xl font-bold mt-8 leading-relaxed w-3/5 max-lg:w-full mx-auto text-center">
              {t("BOOK YOUR")} <br />  {t("SERVICE REQUEST HERE")}
            </h1>
            <img
              src={Vector5}
              className={`w-[320px] ${language == "ar" && "h-[400px]"} max-lg:w-[100px] max-lg:h-[280px] absolute right-44 max-lg:right-2 top-10 max-lg:top-24 z-10`}
            />
          </div>

          <Breadcrumb
            className="text-xl"
            items={[
              {
                title: (
                  <a href="/services" className="text-[#737E91] text-xl max-lg:text-lg">
                    {t("Services")}
                  </a>
                ),
              },
              {
                title: <p className="text-[#737E91] text-xl max-lg:text-lg">{language == "en" ? category?.name_en : category?.name}</p>,
              },
              {
                title: <p className="text-[#737E91] text-xl max-lg:text-lg"> {t("Booking Request")}</p>,
              },
            ]}
          />
        </div>

        <div className="bg-[#FCFBFA] my-10 py-16">
          <div className="text-center">
            <h2 className="text-[#14294F] text-3xl max-lg:text-2xl font-semibold">
              {t("Book Service Request")}
            </h2>
            <p className="text-[#737E91] text-lg mt-3 w-1/2 max-lg:w-full max-lg:px-5 text-center mx-auto">
              {t("Provide us with details of the service you need, and we’ll fix you up with the nearest professional in no time!")}
            </p>
          </div>

          <Form onFinish={handleSubmit} className="mt-10 mx-56 max-lg:mx-5">
            <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-14 max-lg:p-8">
              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10">
                <div>
                  <p className="text-[#283D63]">
                    {t("First_name")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Input
                    placeholder="Eg. Johnny"
                    suffix={<img src={user} className="w-[15px]" />}
                    onChange={handleChange}
                    name="first_name"
                    required={true}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  />
                </div>
                <div>
                  <p className="text-[#283D63]">
                    {t("Last_name")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Input
                    placeholder="Eg. Doe"
                    suffix={<img src={user} className="w-[15px]" />}
                    onChange={handleChange}
                    name="last_name"
                    required={true}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mt-5">
                <div>
                  <p className="text-[#283D63]">
                    {t("Phone Number")} <span className="text-[#CC0F0F]">*</span>
                  </p>

                  <div dir="ltr">
                    <PhoneInput
                      defaultCountry="sa"
                      onChange={(phone) => setPhone(phone)}
                      className={`bg-white w-full p-2 rounded placeholder:text-black placeholder:text-xl placeholder:font-normal placeholder:font-Arimo`}
                    />
                  </div>
                </div>
                <div>
                  <p className="text-[#283D63]">
                    {t("Email")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Input
                    placeholder="Eg. Solimannhene16@gmail.com"
                    suffix={<img src={mail} className="w-[20px]" />}
                    required={true}
                    onChange={handleChange}
                    name="email"
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mt-5">
                <div>
                  <p className="text-[#283D63]">
                    {t("Services")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Select
                    defaultValue="one"
                    className="w-full mt-2"
                    onChange={handleChange}
                    disabled
                    options={[
                      {
                        value: "two",
                        label: "Choose one or more services",
                      },
                      {
                        value: "one",
                        label: language == "en" ? category?.name_en : category?.name,
                      },
                    ]}
                  />
                </div>
                <div>
                  <p className="text-[#283D63]">
                    {t("Sub-Service")}
                  </p>
                  <Select
                    placeholder={t("Choose Sub Service")}
                    className="w-full mt-2"
                    onChange={handleSubServicesSelect}
                    options={category?.sub_category?.map((sub) => ({
                      label: language === "en" ? sub.name_en : sub.name_ar,
                      value: sub.id,
                    }))}
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mt-5">
                <div>
                  <p className="text-[#283D63]">
                    {t("Country")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Select
                    className="w-full mt-2"
                    placeholder={t("Choose country")}
                    value={selectedCountryName}
                    onChange={handleCountrySelect}
                    options={countries?.Country?.map((country) => ({
                      label: language === "en" ? country.name_en : country.name,
                      value: country.id,
                    }))}
                  />
                </div>
                <div>
                  <p className="text-[#283D63]">
                    {t("City")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Select
                    className="w-full mt-2"
                    placeholder={t("Choose city")}
                    value={formData.city_id || null}
                    onChange={(value) => {
                      const selectedCity = cities.find(
                        (city) => city.id === value
                      );
                      setFormData((prev) => ({
                        ...prev,
                        city_id: selectedCity?.id || null,
                      }));
                    }}
                    options={cities.map((city) => ({
                      label: language === "en" ? city.name_en : city.name,
                      value: city.id,
                    }))}
                  />
                </div>
              </div>

              <div className="mt-5">
                <p className="text-[#283D63]">
                  {t("Address")} <span className="text-[#CC0F0F]">*</span>
                </p>
                <Form.Item
                  name="address"
                  rules={[{ required: true, message: t("Please input your address!") }]}
                >
                  <Input
                    placeholder={t("Write tour address in details eg. place / Street / Building name / Apartment")}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                    value={formData.address}
                    onChange={(e) => {
                      setFormData({ ...formData, address: e.target.value });
                      fetchCoordinates(e.target.value);
                    }}
                    required
                  />
                </Form.Item>

              </div>

              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mt-5">
                <div>
                  <p className="text-[#283D63]">
                    {t("Date")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Form.Item
                    name="date"
                    rules={[{ required: true, message: t("Please select a date!") }]}
                  >
                    <DatePicker
                      value={formData.date}
                      onChange={(date, dateString) => setFormData({ ...formData, date: dateString })}
                      placeholder={t("Choose date")}
                      className="w-full mt-2 border-0"
                      disabledDate={(current) => {
                        return current && current < dayjs().startOf('day');
                      }}
                      required
                    />
                  </Form.Item>
                </div>
                <div>
                  <p className="text-[#283D63]">
                    {t("Time")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Form.Item
                    name="time"
                    rules={[{ required: true, message: t("Please select a time!") }]}
                  >
                    <TimePicker
                      value={formData.time}
                      onChange={(time, timeString) => setFormData({ ...formData, time: timeString })}
                      placeholder={t("Choose time")}
                      className="w-full mt-2 border-0"
                      format="HH:mm"
                      required
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="relative">
                <p className="text-[#283D63]">
                  {t("Required documents & request")}
                  <span className="text-[#CC0F0F]">*</span>
                </p>
                <TextArea
                  placeholder={t("Write your request here and upload all the required documents")}
                  allowClear
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  name="description"
                  className="w-full mt-2 border-0 h-[80px] rounded-3xl"
                  required
                />
                <Form.Item
                  name="upload"
                  rules={[{ required: true, message: t("Please upload at least one image!") }]}
                >
                  <Upload
                    fileList={fileList}
                    onChange={handleUploadChange}
                    beforeUpload={() => false}
                    multiple
                    listType="picture"
                  >
                    <img
                      src={camira}
                      className={`w-[40px] absolute ${language == "en" ? "-right-4" : "-left-4"} -top-7 z-10 cursor-pointer`} />

                  </Upload>
                </Form.Item>
              </div>
            </div>
            <Button
              htmlType="submit"
              className="bg-[#FE9B71] text-white rounded-full px-16 w-[150px] py-6 text-lg mt-8 flex mx-auto font-semibold"
            >
              <p>{t("Book")}</p>
            </Button>
            {errorForm && <p>{JSON.stringify(errorForm)}</p>}
          </Form>
        </div>
      </div>

      <div className='px-20 max-lg:px-5 max-lg:hidden'><Steps /></div>
      <OurApp2 />
      <PaymentMethod />
      <Footer />
    </div>
  )
}

export default BookService